import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import Api from '@/services/api';
import type { BaseContext } from '@/types';
import { OWAS_QUERY_KEYS } from '../enums';
import type { OwasTasks } from '@/types/entities/OwasTasks';

type CreateOwasTaskRequest = BaseContext & {
	name: string;
	workstation_id: string;
};

async function createTask(params: CreateOwasTaskRequest): Promise<OwasTasks> {
	const url = `/ergonomic-tool/owas/task`;
	const { data } = await Api.post<OwasTasks>(url, params);
	return data;
}

export const useCreateOwasTask = () => {
	const queryClient = useQueryClient();
	return useMutation<OwasTasks, AxiosError<any>, CreateOwasTaskRequest>((payload) => createTask(payload), {
		onSuccess: () => {
			queryClient.invalidateQueries([OWAS_QUERY_KEYS.GET_TASKS]);
		}
	});
};
